export default "__VITE_ASSET__8ddd67f6__"